import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';
import ComplianceDashboard from '../../common/buttons/complianceDash';

export default function PCIOverview() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const imgRoute = 'images/analytics/pci.png';
  const imgRoute2 = 'images/analytics/pci-2.png';
  const route = baseRoute + imgRoute;
  const route2 = baseRoute + imgRoute2;
  const navigate = useNavigate();
  const handleResponse = (() => {
    navigate('/pciDetails')
  });
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        PCI Overview
      </Typography>
      <ComplianceDashboard></ComplianceDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="PCI Info"
          src={route}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-60px', marginBottom: '-75px' }}
      />
      <img 
          alt="PCI Info 2"
          src={route2}
          width="1472px"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-60px' }}
      />
      <Button
        onClick={handleResponse}
        sx={{ 
          fontSize: '0.65rem',
          marginLeft: "575px", 
          marginTop: '33px',
          marginBottom: '-40px',
          color: '#FFF', 
          bgcolor: '#606662' , 
          height: '22px', 
          '&:hover': {
              backgroundColor: '#1f1e1d',
          } }}>
        Windows User Logoff
      </Button>
      </Box>
    </Container>
  );
};